var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.children.length)?_c('div',{staticClass:"secondary-menu"},[_c('div',{staticClass:"tab-container"},_vm._l((_vm.children),function(child,index){return _c('div',{key:child.name,class:['tab-item', {
                active: child.name === _vm.activeChild,
                disabled: child.disabled
            }],on:{"click":function($event){!child.disabled && _vm.handleTabClick(child.name)}}},[_c('span',{staticClass:"tab-label"},[_vm._v(_vm._s(child.title))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }